import React, {useEffect, useState, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { ListView } from './listView';
import {sendRequest} from '../../../supplementary_components/requests';
import {LoadingIcon} from '../../../supplementary_components/loading_icon';
import {addPopup} from '../../../supplementary_components/store';
import { Form } from '../../forms/Form';
import { userHasAccess, userBelongsToCorrectDepartment } from '../../../supplementary_components/userDataDelegate';
import styles from './listView.module.scss';
import { FiltrationComponent } from './filtrationComponent';
import { CategorySelector } from './categorySelector';
import { ActionDropdown } from './actionDropdown';

const initialCategory = (viewStructure, initialCategoryLabel) => {
    const options = viewStructure.categorizedList?.options;
    if (!options) return null;
    if (initialCategoryLabel) {
        return options.find((option) => option.label === initialCategoryLabel) || options[0];
    }
    const index = viewStructure.categorizedList.defaultOptionIndex;
    return index !== undefined ? options[index] : options[0];
};

export const ItemsListingPage = ({ViewStructure, itemIdentifier, initialCategoryLabel})=> {
    if(ViewStructure.processViewStructure){
        ViewStructure = ViewStructure.processViewStructure(ViewStructure);
    }
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(() => initialCategory(ViewStructure, initialCategoryLabel));
    const [filteredData, setFilteredData] = useState(null);
    const [pagonationData, setPagonationData] = useState({"currentPageNumber":0});
    const [error, setError] = useState(null);
    const [updateAvailable, setUpdateAvailable] = useState(!ViewStructure.skipListRequest);
    const currentUserDepartment = localStorage.getItem("department");
    const listRef = useRef(null);
    const _seData = (data) => {
        setUpdateAvailable(false);
        setData(data.dataset);
        delete data["dataset"]; 
        if(ViewStructure.processWarningData && data.warningData){
            ViewStructure.categorizedList = ViewStructure.processWarningData(data.warningData, ViewStructure.categorizedList);
            delete data["warningData"]; 
        }
        if("selectedType" in data){
            try {
                for(const option of ViewStructure.categorizedList.options){
                    if(option.label === data.selectedType){
                        setSelectedCategory(option);
                        break;
                    }
                }
            } catch (e) {
            }
            delete data["selectedType"];
        }
        
        setPagonationData(data);
    }
    const RequstReload = () => {
        setUpdateAvailable(true);
    }
    const _setSelectedCategory = (category) => {
        setSelectedCategory(category);
        if (category?.path && category.path !== window.location.pathname) {
            navigate(category.path);
        }
        if (!ViewStructure.skipListRequest) {
            setUpdateAvailable(true);
        }
    }
    
    useEffect(
        () => {
            if (ViewStructure.skipListRequest) {
                if (updateAvailable) {
                    setUpdateAvailable(false);
                }
                return;
            }
            if(updateAvailable){
                setError(null);
                const controller = new AbortController();
                const signal = controller.signal;
                const categoryQuery = selectedCategory
                    ? `&category=${selectedCategory.label}`
                    : '';
                sendRequest(
                    'GET',
                    ViewStructure.getRequestLink + (itemIdentifier !== null && itemIdentifier !== ''
                        ? "/" + itemIdentifier
                        : `?pageNumber=${pagonationData.currentPageNumber || 0}${categoryQuery}`),
                    signal,
                    _seData,
                    setError,
                    null
                );
                
                return () => {
                    // cancel the request before component unmounts
                    controller.abort();
                };
            }
        // eslint-disable-next-line
        }, [ViewStructure, updateAvailable]
    );
    if (!ViewStructure.skipListRequest && data==null && error ==null)return<LoadingIcon state={true} height={'10rem'} />;
    return (
        <>
        <div className={styles.pageHeader}>
            <div>{ViewStructure.dataTitlePlural}</div>
            <div className={styles.actionsContainer}>
                {!ViewStructure.filtration || <FiltrationComponent filtrationData={ViewStructure.filtration} dataset={data} setFilteredData={setFilteredData} />}
                {ViewStructure.specialActions ?
                    ViewStructure.specialActions.map((action, index)=>{
                        if(action.requiredPermission
                            ? userHasAccess(action.requiredPermission)
                            : (!action.requiredDepartment || currentUserDepartment === action.requiredDepartment || (Array.isArray(action.requiredDepartment) && action.requiredDepartment.includes(currentUserDepartment)))){
                            const triggerClassName = `${action.notGreenButton ? styles.notGreenButton : ''} ${styles.addButton} non-selectable`;
                            if (action.menuItems) {
                                return (
                                    <ActionDropdown
                                        key={index}
                                        action={action}
                                        triggerClassName={triggerClassName}
                                        requestReload={RequstReload}
                                        selectedCategory={selectedCategory}
                                    />
                                );
                            }
                            return <div key={index} className={triggerClassName}>
                                <div onClick={() => { action.onClick(RequstReload, selectedCategory); }}>{action.buttonLabel}
                                    <div className="actionIcon">{action.icon}</div>
                                </div>
                            </div>
                        }
                        return null;
                    })
                :null}
                
                <div>
                    {(selectedCategory && selectedCategory.noAddButton) ? null : ViewStructure.addButton && userHasAccess(ViewStructure.addConf.formAccessLevel) && (!ViewStructure.addConf.formAccessDepartment || userBelongsToCorrectDepartment(ViewStructure.addConf.formAccessDepartment)) ?
                        <div className={`${styles.addButton} non-selectable`} onClick={() => addPopup({ content: Form, popupData: { configuration: ViewStructure.addConf }, postSuccessAction: RequstReload, EZCloseAllowed: ViewStructure.EZCloseAllowed })}>Add {ViewStructure.dataTitle} +</div> : null}
                </div>
            </div>
            
        </div>
        {ViewStructure.categorizedList ? <CategorySelector data={ViewStructure.categorizedList} selectedCategory={selectedCategory} setSelectedCategory={_setSelectedCategory} loading={updateAvailable} requestReload={RequstReload} /> : null}
        {!ViewStructure.skipListRequest && updateAvailable?<LoadingIcon state={true} height={listRef.current?`${listRef.current.clientHeight}px`:'50vh'} />:null}
        {selectedCategory && selectedCategory.categorySpecificComponent ? <selectedCategory.categorySpecificComponent dataset={data} /> :
        (() => {
            const listView = (
                <ListView
                    listRef={listRef}
                    ListConf={ViewStructure}
                    Data={data}
                    filteredData={filteredData}
                    Error={error}
                    RequestReload={RequstReload}
                    PaginationData={{
                        data: pagonationData,
                        setPaginationData: setPagonationData
                    }}
                    listBeingUpdated={updateAvailable}
                    selectedCategory={selectedCategory?.label ?? null}
                    setData = {setData}
                    setFilteredData = {setFilteredData}
                />
            );
            const ListWrapper = ViewStructure.listWrapper;
            return ListWrapper ? <ListWrapper>{listView}</ListWrapper> : listView;
        })()}
        </>
    )
}

